import { Modal } from "flowbite-react";
import FormDeleteProduct from "../form/FormDeleteProduct";

type Props = {
    onClose: () => void;
    onSave: (productId: string) => void;
    productId: string;
    code: string;
};

export default function DeleteProduct({ onClose, onSave, productId, code }: Props) {
    const handleCloseModal = () => onClose?.();

    return (
        <Modal

            className="relative text-black"
            show={true}
            size="md"
            onClose={handleCloseModal}
        >
            <Modal.Header className="[&>button]:hidden">
                <p className="text-black text-[18px] font-bold">Confirmar exclusão</p>
                <span className="text-gray-600 text-locavibe">{code}</span>
            </Modal.Header>

            <Modal.Body className="text-black dark:text-black">
                <FormDeleteProduct
                    productId={productId}
                    onCancel={handleCloseModal}
                    onDeleted={(id) => onSave(id)}
                />
            </Modal.Body>
        </Modal>
    );
}

